export { default } from "./StudentDetail";

